import React from "react";
import "./TranslationHeadContent.css";
const TranslationHeadContent = () => {
  return (
    <div className="transHeadContent">
      <h1>
        Translation Services in Bangalore by <span>Goodway Attestation</span>
      </h1>
      <p>
        Welcome to Goodway Attestation’s professional translation services in
        Bangalore! We are your one-stop destination for accurate and reliable
        language translation solutions. With our team of experienced translators
        and a commitment to quality, we ensure that your documents are
        translated with precision and cultural sensitivity. Whether you need
        translation services for personal, professional, or business purposes,
        we have got you covered.
      </p>
    </div>
  );
};

export default TranslationHeadContent;
